export default class TreeSelectionHandler {

  static NONE = 'none';
  static SINGLE = 'single';
  static MULTIPLE = 'multiple';
  static TOGGLE = 'toggle';

  constructor(type = TreeSelectionHandler.SINGLE, nestedKey = 'children') {
    this.type = type;
    this.nestedKey = nestedKey;
  }

  static clearSelection() {
    return {};
  }

  static getNodeFromKey(items = [], nestedKey, key = '') {
    const indexes = key.split('.').map(id => parseInt(id, 10));
    let item;

    for (let i = 0; i <= indexes.length - 1; i++) {
      item = items[indexes[i]];
      if (!item) {
        break;
      }
      items = item[nestedKey]; // eslint-disable-line no-param-reassign
    }
    return item;
  }

  static getNumberOfSelectedItems(selection = {}) {
    return Object.keys(selection).length;
  }

  getSelectedItems(root, selection = {}) {
    const items = [];

    Object.keys(selection).forEach(key => {
      const item = TreeSelectionHandler.getNodeFromKey(root, this.nestedKey, key);

      if (item) {
        items.push(item);
      }
    });
    return items;
  }

  handleSelectionEvent(root, cellKey, selection = {}, e) {
    if (this.type === TreeSelectionHandler.SINGLE) {
      return selection[cellKey] ? selection : { [cellKey]: true };
    } else if (this.type === TreeSelectionHandler.TOGGLE) {
      const newSelection = { ...selection };

      if (newSelection[cellKey]) {
        delete newSelection[cellKey];
      } else {
        newSelection[cellKey] = true;
      }
      return newSelection;
    }
    return selection;
  }

  static hasSelection(selection) {
    return selection.keys().length > 0;
  }

  static selectAll(root = {}) {
    const selection = {};
    // TOO select all items
    return selection;
  }

}
